import { render, staticRenderFns } from "./l1.vue?vue&type=template&id=29f2a189"
import script from "./l1.vue?vue&type=script&lang=js"
export * from "./l1.vue?vue&type=script&lang=js"
import style0 from "./l1.vue?vue&type=style&index=0&id=29f2a189&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports